import React, { Component } from 'react';
import ApiDocFormContent from './apiDocFormContent'
import ApiDocContent from './apiDocContent'
import './index.css'
import { Route, Switch, NavLink } from "react-router-dom";
import BsyDialog from "../BsyMsgBubble";
import { BsyUtils } from "../../utils/Utils";
import DocumentTitle from "react-document-title";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { setPageTitle } from '../../utils/setPageTitle';

class BsyWebhookApiDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [{
                id: "overview",
                name: React.language("api.intro")
            }, {
                id: "limit",
                name: React.language("api.limit")
            }, {
                id: "authorization",
                name: React.language("api.auth")
            }, {
                id: "errorCode",
                name: React.language("api.error.table")
            }],
            formType: [],
            formTypeCont: [],
            menuDataList: [],
            appName: "",
            apps: [],
            thisApp: {},
            success: false
        }

        if (props.match.params.mode === "app") {
            this.state.menuList.push({
                id: "postCode",
                name: React.language("post.Code")
            })
        }
        this.tree = React.createRef()
        this.docCont = React.createRef()
    }

    componentDidMount() {
        this.loadMenu();
    }

    onDocScroll = () => {
        this.docCont.current.addEventListener('scroll', this.scrollFunc, false)
    }

    scrollFunc = (event) => {
        let y = ["overview", "limit", "authorization", "errorCode", "postCode"];
        let p = this.state.formType.map((res) => {
            return res.key
        });
        let _this = this;
        let n = null
        let dTop = this.docCont.current.scrollTop
        let hList = this.docCont.current.getElementsByClassName("api-h1")
        for (let i = 0; i < hList.length; i++) {
            let t = hList[i].offsetTop;
            if (t >= dTop - 30 && t <= dTop + 30) {
                n = hList[i]
            }
        }
        if (n) {
            for (let i = 0; i < n.classList.length; i++) {
                if (y.indexOf(n.classList[i]) > -1) {
                    _this.props.history.push(`${window.rootDirectroy}/webapi/docinfo/${this.props.match.params.mode}/${this.props.match.params.id}/${n.classList[i]}`)
                }
                if (p.indexOf(n.classList[i]) > -1) {
                    let g = _this.props.location.pathname.split("/");
                    if (g[7] === n.classList[i]) {
                        return
                    }
                    _this.props.history.push(`${window.rootDirectroy}/webapi/docinfo/${this.props.match.params.mode}/${g[g.length - 4]}/entry/${g[g.length - 2]}/${n.classList[i]}`)
                }
            }
        }
    }

    loadDoc = (i) => {
        let formType = [];
        let formTypeCont = [];
        let e = this.props.match.params.id;
        let m = this.props.match.params.mode;
        React.axios("/webapi/api_description", { type: m, index: e, key: i }).then((res) => {
            BsyUtils.forEach(res.data, (key, res) => {
                formType.push({
                    key: res.key,
                    name: res.name
                });
                res.version = 0;
                formTypeCont.push(res);
            })
            this.setState({
                formTypeCont,
                formType
            })
        })
    }

    loadMenu = () => {
        let e = this.props.match.params.id;
        let i = this.props.match.params.entryId;
        let m = this.props.match.params.mode;
        let formType = [];
        let formTypeCont = [];
        React.axios("/webapi/doclist", {}).then((res) => {
            let app = {}
            let apps = []
            if (m === "app") {
                res.data.app.map((res1) => {
                    res1.apps.map(res2 => {
                        apps.push(res2)
                        if (res2._id === e) {
                            app = res2;
                        }
                    })
                })
            } else if (m === "corp") {
                res.data.corp.map((res1) => {
                    apps.push(res1)
                    if (res1._id === e) {
                        app = res1;
                    }
                })
            } else if (m === "platform") {
                res.data.platform.map((res1) => {
                    apps.push(res1)
                    if (res1._id === e) {
                        app = res1;
                    }
                })
            }


            React.axios("/webapi/api_description", { type: m, index: e, key: i }).then((res00) => {
                BsyUtils.forEach(res00.data, (key, res) => {
                    formType.push({
                        key: res.key,
                        name: res.name
                    });
                    res.version = 0;
                    formTypeCont.push(res);
                })
                React.axios("/webapi/api_list", { type: m, key: e }).then((res0) => {
                    this.setState({
                        formTypeCont,
                        formType,
                        menuDataList: res0.data,
                        success: true,
                        apps: apps,
                        thisApp: app,
                        appName: app.name
                    }, () => {
                        this.onDocScroll()
                    })
                })
            })

        })
    }

    prevEntryId = this.props.match.params.entryId;

    selectItem = (res) => {
        return () => {
            if (this.prevEntryId !== res) {
                this.loadDoc(res)
                this.prevEntryId = res;
            }
        }
    }

    openItem = (event) => {
        let l = event.currentTarget.parentNode.getElementsByTagName("ul")[0].getElementsByTagName("li").length;
        let e = event.currentTarget;
        if (e.classList.value.indexOf("open") > -1) {
            e.classList.remove("open");
            e.parentNode.getElementsByTagName("ul")[0].style.height = 0 + "px";
            setTimeout(() => {
                e.parentNode.getElementsByTagName("ul")[0].style.display = "none";
            }, 218)
        } else {
            e.classList.add("open");
            e.parentNode.getElementsByTagName("ul")[0].style.display = "block";
            setTimeout(() => {
                e.parentNode.getElementsByTagName("ul")[0].style.height = (l * 36 + "px");
            }, 30)
        }
    }

    openAllApp = (event) => {
        const { apps } = this.state;
        let m = this.props.match.params.mode
        BsyDialog({
            anchor: event.currentTarget,
            contentHTML: () => {
                return (<div className="bby-all-app">
                    {
                        apps.map((res) => {
                            return <a className={"app-item " + (this.props.match.params.id === res._id ? "selected" : "")} href={window.rootDirectroy + "/webapi/docinfo/" + this.props.match.params.mode + "/" + res._id + "/overview"} target="_blank">
                                <div className="app-view" title={res.name}>
                                    <div className="app-icon">
                                        {m === "app" ? <div className={"icon-backgroup color-cover-" + res.style.color}>
                                            <div className={"imgbg-bby-app imgbg-bby-app-" + res.style.icon} />
                                        </div> : <i className={"icon-bsy-api-" + res.style.icon + " api-color-" + res.style.color} />}
                                    </div>
                                    <div className="app-title">
                                        {res.name}
                                    </div>
                                </div>
                            </a>
                        })
                    }
                </div>)
            },
            text4Cancel: null,
            text4Ok: null,
            width: 260,
            height: 400,
            contentPadding: 0,
            hAdjust: -6,
            edge: 200,
            dockPosition: "left",
            // "margin-top":20,
            onClose: function () {
                return !1;
            }
        })
    }

    toBack = () => {
        this.props.history.push(`${window.rootDirectroy}/open/api`)
    }

    render() {
        const { menuList, menuDataList, appName, thisApp, success, formTypeCont, formType } = this.state;
        let m = this.props.match.params.mode
        setPageTitle("WebApi - " + appName);
        return (

            <div className="BsyWebhookApiDoc">
                {success && <>
                    <div className="api-header">
                        {thisApp.style && <div className="appName" onClick={this.openAllApp}>
                            <div className="app-icon">
                                {m === "app" ? <div className={"icon-backgroup color-cover-" + thisApp.style.color}>
                                    <div className={"imgbg-bby-app imgbg-bby-app-" + thisApp.style.icon} />
                                </div> : <i
                                    className={"icon-bsy-api-" + thisApp.style.icon + " api-color-" + thisApp.style.color} />}
                            </div>
                            <span>{appName}</span>
                            <i className="icon-bsy-xia" />
                        </div>}
                    </div>
                    <div className="api-body">
                        <div className="api-menu">
                            <ul className="menu-tree" ref={this.tree}>
                                {
                                    menuList.map((res) => {
                                        return <li key={res.id} id={res.id}>
                                            <NavLink to={`${window.rootDirectroy}/webapi/docinfo/${this.props.match.params.mode}/${this.props.match.params.id}/${res.id}`} activeClassName="selected" className="item" title={res.name} onClick={this.selectItem(res.entryId)}>
                                                <span>{res.name}</span>
                                            </NavLink>
                                        </li>
                                    })
                                }
                                {
                                    menuDataList && menuDataList.length > 0 && menuDataList.map((res) => {
                                        return res.key && <li key={res.key} id={res.key}>
                                            <div className="item" title={res.name} onClick={this.openItem}>
                                                <span>{res.name}</span>
                                                <i className="icon-tips" />
                                            </div>
                                            <ul>
                                                {
                                                    res.group && res.group.map((res2) => {
                                                        return <li id={res2.key}>
                                                            <NavLink to={`${window.rootDirectroy}/webapi/docinfo/${this.props.match.params.mode}/${this.props.match.params.id}/entry/${res.key}/${res2.key}`} activeClassName="selected" className="item" title={res2.name} onClick={this.selectItem(res.key)}>
                                                                <span>{res2.name}</span>
                                                            </NavLink>
                                                        </li>
                                                    })
                                                }
                                            </ul>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                        <div className="api-doc" ref={this.docCont}>
                            <div className="api-content">
                                <Switch>
                                    <Route path={window.rootDirectroy + "/webapi/docinfo/:mode/:id/entry/:entryId/:type"} >
                                        <ApiDocFormContent formTypeCont={formTypeCont} />
                                    </Route>
                                    <Route path={window.rootDirectroy + "/webapi/docinfo/:mode/:id/:type"}>
                                        <ApiDocContent />
                                    </Route>
                                </Switch>
                            </div>
                        </div>
                    </div>
                </>}
            </div>


        );
    }
}

export default withRouter(BsyWebhookApiDoc);